import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-responsive-bs5';
import 'datatables.net-rowgroup-bs5';
import 'datatables.net-buttons/js/buttons.colVis.min';
import 'datatables.net-buttons/js/buttons.html5.min';
import { extendDataTablesClasses } from 'datatables_classes';
import { dataTablesDefault } from 'datatables_default';

var KTDatatablesBasicBasic = {
  init: function(){
    extendDataTablesClasses();

    $( '.datatables-net' ).each( function(){
      // The data-visible HTML data attributes do not function in datatables-net 2.x.
      // Therefore, the column definition is modified before initialization.
      var columnDefs = [],
          dataTableSettings,
          dataTable,
          $this = $( this ),
          disableExport;

      // Check if export should be disabled
      disableExport = $this.data( 'disable-export' ) === true;

      // Collect column visibility settings from the <th> elements.
      $this.find( 'thead th' ).each( function( index ){
        var visible = $( this ).data( 'visible' ) !== false; // Default to true if not specified
        columnDefs.push( { targets: index, visible: visible } );
      } );

      // Create a copy of the default settings and include the columnDefs
      dataTableSettings = $.extend( {}, dataTablesDefault, {
        columnDefs: columnDefs
      } );

      // Remove export button if disabled
      if( disableExport && dataTableSettings.buttons && dataTableSettings.buttons.buttons ){
        dataTableSettings.buttons.buttons = dataTableSettings.buttons.buttons.filter( function( button ){
          return button.extend !== 'csvHtml5';
        } );
      }

      dataTable = $this.DataTable( dataTableSettings );

      dataTable.on( 'column-visibility.dt', function(){
        // Update the state of "Select all" button based on column visibility
        var columns = dataTable.columns().visible().toArray();
        $( dataTable.table().container() ).find( '.select-all' ).toggleClass( 'dt-button-active', columns.every( Boolean ) );
        $( dataTable.table().container() ).find( '.select-all' ).toggleClass( 'indeterminate', !columns.every( Boolean ) && columns.some( Boolean ) );
      } );

      window.data_tables.push( dataTable );
    } );
  }
};

$( function(){
  window.data_tables = [];
  KTDatatablesBasicBasic.init();
} );
